import { gql } from "@apollo/client";

export const IS_CHATBOT_ENABLED_CHANGED = gql`
  subscription isChatbotEnabledChanged($projectId: ID!) {
    projectInformationChanged(projectId: $projectId) {
      isChatbotEnabled
    }
  }
`;
